//External Libraries
import * as React from "react";
import { PINEntryFailure, PINEntrySuccess } from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";
import * as RDS from "ouisys-clients/dist/common-types/RemoteDataState";
import Loader from "../Loader/index";

//Translations
import { Translate, injectIntl } from "../../localization/index";

//SCSS
import "./PINEntryStep.scss";

console.log(process.env.country, process.env.scenario)

class PINEntryStep extends React.PureComponent<{
  msisdn: string;
  rds: RDS.RemoteDataState<PINEntryFailure, PINEntrySuccess>;
  backToStart: () => void;
  onEnd: (pin: string) => void;
  actualPIN?: string
}> {
  state = {
    pin: this.props.actualPIN || ''
  };
  render() {
    return (
      <form className="pin-entry"
        onSubmit={ev => {
          ev.preventDefault();
          this.props.onEnd(this.state.pin);
        }}
      >
        <h1>
          <Translate id="we_just_sent_a_pin" defaultMessage="We just sent a PIN to your mobile phone. Please check your SMS inbox and enter the PIN that you received below:" />
        </h1>

        <div>
          <input
            type="tel"
            placeholder="PIN"
            value={parseInt(this.state.pin) >= 0 ? this.state.pin : "" }
            onChange={ev => this.setState({ pin: ev.target.value })}
            minLength={4}
            maxLength={4}
          />

          {
            RDS.WhenLoading(null, () => <div className="msg">
              <Loader />
              <div>...</div>
            </div>)(this.props.rds)
          }
        </div>
        <div>
          {
            RDS.match<PINEntryFailure, PINEntrySuccess, any>({
              failure: (err: PINEntryFailure) => (
                <div className="error">
                  <div><Translate id={err.errorType} /></div>
                  <Translate
                    id="if_not_your_mobile"
                    defaultMessage="If {phone} is not your mobile number,"
                    values={{
                      phone: this.props.msisdn
                    }} />&nbsp;
                    <a onClick={() => this.props.backToStart()}>
                    <Translate id="click_here_to_change_your_number" defaultMessage="Click here to change your phone number." />
                  </a>
                </div>
              ),
              nothingYet: () => (
                <div className="msg">
                  <Translate id="didnt_receive_pin_yet" values={{
                    phone: this.props.msisdn
                  }} />&nbsp;
                    <a onClick={() => this.props.backToStart()}>
                    <Translate id="click_here_to_change_your_number" defaultMessage="Click here to change your phone number." />
                  </a>
                </div>
              ),
              loading: () => null,
              success: ({ finalUrl }) => null
            })(this.props.rds)
          }
        </div>

        <button type="submit" className="btn submit-pin" disabled={RDS.IsLoading(this.props.rds) || this.state.pin.length < 4}><Translate id="btnPin" defaultMessage="confirm" /></button>

      </form>
    );
  }
}

export default injectIntl(PINEntryStep);
